/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../src/app/app.module';
import * as i2 from '../../../src/app/app.component';
import * as i3 from './app.component.ngfactory';
import * as i4 from '@angular/common';
import * as i5 from '@angular/platform-browser';
import * as i6 from '@angular/animations/browser';
import * as i7 from '@angular/platform-browser/animations';
import * as i8 from '@angular/forms';
import * as i9 from '@angular/http';
import * as i10 from '@angular/animations';
import * as i11 from '@agm/core/utils/browser-globals';
import * as i12 from '@agm/core/services/maps-api-loader/maps-api-loader';
import * as i13 from '@agm/core/services/maps-api-loader/lazy-maps-api-loader';
import * as i14 from '../../../src/app/services/donnee.service';
import * as i15 from '@agm/core/core.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i4.NgLocalization,
              i4.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
              i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
              i0.ɵl,([] as any[])),i0.ɵmpd(4608,i5.DomSanitizer,i5.ɵe,[i4.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i5.DomSanitizer]),i0.ɵmpd(4608,
              i5.HAMMER_GESTURE_CONFIG,i5.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i5.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i5.ɵDomEventsPlugin(p0_0),new i5.ɵKeyEventsPlugin(p1_0),
                    new i5.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i4.DOCUMENT,i4.DOCUMENT,i4.DOCUMENT,i5.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i5.EventManager,i5.EventManager,[i5.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i5.ɵDomSharedStylesHost,i5.ɵDomSharedStylesHost,[i4.DOCUMENT]),
          i0.ɵmpd(4608,i5.ɵDomRendererFactory2,i5.ɵDomRendererFactory2,[i5.EventManager,
              i5.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i6.AnimationDriver,i7.ɵc,([] as any[])),
          i0.ɵmpd(5120,i6.ɵAnimationStyleNormalizer,i7.ɵd,([] as any[])),i0.ɵmpd(4608,
              i6.ɵAnimationEngine,i7.ɵb,[i6.AnimationDriver,i6.ɵAnimationStyleNormalizer]),
          i0.ɵmpd(5120,i0.RendererFactory2,i7.ɵe,[i5.ɵDomRendererFactory2,i6.ɵAnimationEngine,
              i0.NgZone]),i0.ɵmpd(6144,i5.ɵSharedStylesHost,(null as any),[i5.ɵDomSharedStylesHost]),
          i0.ɵmpd(4608,i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i5.Meta,
              i5.Meta,[i4.DOCUMENT]),i0.ɵmpd(4608,i5.Title,i5.Title,[i4.DOCUMENT]),
          i0.ɵmpd(4608,i8.ɵi,i8.ɵi,([] as any[])),i0.ɵmpd(4608,i9.BrowserXhr,i9.BrowserXhr,
              ([] as any[])),i0.ɵmpd(4608,i9.ResponseOptions,i9.BaseResponseOptions,
              ([] as any[])),i0.ɵmpd(5120,i9.XSRFStrategy,i9.ɵb,([] as any[])),i0.ɵmpd(4608,
              i9.XHRBackend,i9.XHRBackend,[i9.BrowserXhr,i9.ResponseOptions,i9.XSRFStrategy]),
          i0.ɵmpd(4608,i9.RequestOptions,i9.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i9.Http,i9.ɵc,[i9.XHRBackend,i9.RequestOptions]),i0.ɵmpd(4608,i10.AnimationBuilder,
              i7.ɵBrowserAnimationBuilder,[i0.RendererFactory2]),i0.ɵmpd(4608,i11.WindowRef,
              i11.WindowRef,([] as any[])),i0.ɵmpd(4608,i11.DocumentRef,i11.DocumentRef,
              ([] as any[])),i0.ɵmpd(4608,i12.MapsAPILoader,i13.LazyMapsAPILoader,
              [i13.LAZY_MAPS_API_CONFIG,i11.WindowRef,i11.DocumentRef]),i0.ɵmpd(4608,
              i14.DonneeService,i14.DonneeService,[i9.Http]),i0.ɵmpd(512,i4.CommonModule,
              i4.CommonModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i5.ɵa,([] as any[])),
          i0.ɵmpd(1024,i0.APP_INITIALIZER,(p0_0:any,p0_1:any) => {
            return [i5.ɵc(p0_0,p0_1)];
          },[[2,i5.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i5.BrowserModule,i5.BrowserModule,[[3,i5.BrowserModule]]),i0.ɵmpd(512,
              i8.ɵba,i8.ɵba,([] as any[])),i0.ɵmpd(512,i8.FormsModule,i8.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i9.HttpModule,i9.HttpModule,([] as any[])),
          i0.ɵmpd(512,i7.BrowserAnimationsModule,i7.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i15.AgmCoreModule,i15.AgmCoreModule,([] as any[])),i0.ɵmpd(512,
              i1.AppModule,i1.AppModule,([] as any[])),i0.ɵmpd(256,i13.LAZY_MAPS_API_CONFIG,
              {apiKey:'AIzaSyAv5xs9SIu2ZVaR1pPX1rAfHhxK7cAT6IA'},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTWlndWVsL0Rlc2t0b3AvY2FydGUtbWFyaWFsZS1jb2RlL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9NaWd1ZWwvRGVza3RvcC9jYXJ0ZS1tYXJpYWxlLWNvZGUvc3JjL2FwcC9hcHAubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./ngfactory/src/app/app.module.ngfactory.ts